export default __webpack_public_path__ + "static/media/TKH_Logo_Allpurple.6efa3207.png";